/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "giftcard": {
        "nested": {
          "model": {
            "nested": {
              "GiftCardTag": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "giftCardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "category": {
                    "type": "squareup.giftcard.model.GiftCardTag.Category",
                    "id": 4,
                    "rule": "optional"
                  },
                  "tag": {
                    "type": "squareup.giftcard.model.GiftCardTag.Tag",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Category": {
                    "values": {
                      "CATEGORY_DO_NOT_USE": 0,
                      "FUNDING_SOURCE": 1,
                      "ATTRIBUTE": 2
                    }
                  },
                  "Tag": {
                    "values": {
                      "TAG_DO_NOT_USE": 0,
                      "FUNDING_SOURCE_ONLINE": 1,
                      "FUNDING_SOURCE_POS": 2,
                      "FUNDING_SOURCE_PRELOAD": 3,
                      "FUNDING_SOURCE_REFUND": 4,
                      "FUNDING_SOURCE_API": 5,
                      "FUNDING_SOURCE_THIRD_PARTY": 6,
                      "UNUSED_SINCE_ACTIVATION": 7,
                      "MIGRATED_FROM_OTHER_ACCOUNT": 8,
                      "PURCHASED_IN_BULK": 9,
                      "PURCHASED_WITH_DISCOUNT": 10,
                      "FUNDING_SOURCE_MARKETPLACES_API": 11
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCardTag && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCardTag?.nested?.Category && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCardTag?.nested?.Tag) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GiftCardTag @ squareup/giftcard/model/gift_card_tag.proto at 9:1
 */
export const GiftCardTag = $root.lookupType('squareup.giftcard.model.GiftCardTag');
fixType(GiftCardTag);
Builder.createAndAttachToType(GiftCardTag);
/**
 * SOURCE Category @ squareup/giftcard/model/gift_card_tag.proto at 10:3
 */
GiftCardTag.Category = $root.lookupEnum('squareup.giftcard.model.GiftCardTag.Category').values;
/**
 * SOURCE Tag @ squareup/giftcard/model/gift_card_tag.proto at 16:3
 */
GiftCardTag.Tag = $root.lookupEnum('squareup.giftcard.model.GiftCardTag.Tag').values;